// Table component constants

// Page identifiers
export const PAGE_IDENTIFIERS = {
  CAMERAS_TAB: "CamerasTab",
  ASSOCIATED_CAMERAS_TAB: "AssociatedCamerasTab",
  COMPANION_TAB: "CompanionTab",
  DISCOVERED_CAMERAS_TAB: "DiscoveredCamerasTab",
  COMPANION_DEVICES_TAB: "CompanionDevicesTab",
  CAMERA_EVENTS: "cameraEvents",
  ALERTS: "Alerts",
  USER_TABLE: "UserTable",
  USER_GROUPS: "UserGroups",
  PENDING_INVITES: "PendingInvites",
  LICENSES: "Licenses",
  SITES: "Sites"
};

// Filter keys
export const FILTER_KEYS = {
  LOCATION: "Location",
  STATUS: "Status",
  STREAMS: "Streams",
  ROLE: "role",
  SITE: "site"
};

// Filter keys
export const TOOLTIP_TITLES = {
  ONBOARDING_STATUS: "On-boarding status",
  ONBOARDING_TYPE: "On-boarding type",
  TYPE: "Type",
  STREAM_ID: "Stream Id",
  MANUAL_RTSP: "Manual (RTSP)",
  LICENSE_TYPE: "License type",
};


// Location filter prefixes
export const LOCATION_PREFIXES = {
  SITE: "site_",
  FLOOR: "floor_",
  AREA: "area_"
};

// Location filter types (without underscore)
export const LOCATION_TYPES = {
  SITE: "site",
  FLOOR: "floor",
  AREA: "area"
};

// Device status values
export const DEVICE_STATUS = {
  READY: "ready",
  REGISTERED: "registered",
  ONLINE: "online",
  OFFLINE: "offline"
};

// Device status display names
export const DEVICE_STATUS_DISPLAY = {
  ONBOARDED: "Onboarded",
  NOT_CALIBRATED: "Not Calibrated",
  CALIBRATING: "Calibrating",
  ONLINE: "Online",
  OFFLINE: "Offline",
  PENDING: "Pending"
};

// UI text constants
export const TABLE_UI_TEXT = {
  SEARCH_PLACEHOLDER: "Search",
  UPDATED_LABEL: "Updated:",
  NO_PERMISSION: "No Permission",
  NEW_BADGE_LABEL: "New"
};

// Date format constants
export const TABLE_DATE_FORMATS = {
  DATE: "MMM. D, YYYY",
  TIME: "h:mm A"
};

// Table field keys
export const TABLE_FIELDS = {
  FIELDS: "fields",
  CALIBRATION: "calibration",
  STATUS: "status"
};

// Priority levels
export const PRIORITY_LEVELS = {
  CRITICAL: "critical"
};

// Firmware upgrade state values
export const FW_UPGRADE_STATE = {
  SUCCESS: "success",
  INPROGRESS: "inprogress"
};
